import React, { useEffect, useRef, useState } from 'react'

type DropDownContainerProps = {
  isShow: boolean
}

const DropdownContainer: React.FC<DropDownContainerProps> = ({ isShow, children }) => {
  const contentRef = useRef<HTMLDivElement | null>(null)
  const [height, setHeight] = useState('0px')

  useEffect(() => {
    const el = contentRef.current
    if (el) {
      setHeight(isShow ? `${el.scrollHeight}px` : '0px')
    }
  }, [isShow])

  return (
    <div className="collapsible-wrapper" style={{ height }}>
      <div className="collapsible-content" ref={contentRef}>
        {children}
      </div>
    </div>
  )
}

export default DropdownContainer
